import { selectSelectedDeviceId } from 'features/Integrations/state/selectors/deviceSelectors';
import { useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  useGetConnectedDevicesQuery,
  useUpdateConnectedDeviceMutation,
} from 'services/devices/devices.api';

export default function USGSDeviceSettings({ onClose }) {
  const { data: connectedDevices = [] } = useGetConnectedDevicesQuery();
  const [updateConnectedDevice] = useUpdateConnectedDeviceMutation();
  const selectedDeviceId = useSelector(selectSelectedDeviceId);

  const device = connectedDevices.find((d) => d.id === selectedDeviceId) || null;

  const [alias, setAlias] = useState(device?.alias || '');
  const [saving, setSaving] = useState(false);

  const hasChanges = alias !== (device?.alias || '');

  const handleSave = async () => {
    if (!device || !hasChanges) return;

    setSaving(true);

    try {
      await updateConnectedDevice({
        id: device.id,
        alias: alias,
        device_type: device.device_type,
        system_type: device.system_type,
        new_node_id: device.node_id,
        node_id: device.node_id,
        location: device.coordinates,
      }).unwrap();
    } catch (error) {
      console.error('Failed to update USGS device alias:', error);
    } finally {
      setSaving(false);
    }
  };

  if (!device) {
    return (
      <Container fluid className="py-3 text-white">
        <Alert variant="warning">Device not found.</Alert>
      </Container>
    );
  }

  const cardClassName = 'bg-primary-highlight text-white border-1';
  const cardHeaderClassName = 'bg-primary text-white';
  const cardBodyClassName = 'bg-base rounded-2';
  const fieldClassName = 'bg-primary text-white border-0';

  return (
    <Container fluid className="py-3 text-white">
      <div className="d-flex flex-column gap-3">
        <Card className={`shadow-sm ${cardClassName}`}>
          <Card.Header className={cardHeaderClassName}>Device Settings</Card.Header>
          <Card.Body className={`d-flex flex-column gap-3 ${cardBodyClassName}`}>
            <Form.Group as={Row} className="align-items-center g-2">
              <Form.Label column lg={4} className="mb-0 fw-semibold">
                Alias
              </Form.Label>
              <Col lg={8}>
                <Form.Control
                  className={fieldClassName}
                  type="text"
                  value={alias}
                  onChange={(e) => setAlias(e.target.value)}
                  placeholder="Enter device alias"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="align-items-center g-2">
              <Form.Label column lg={4} className="mb-0 fw-semibold text-muted">
                Site Number
              </Form.Label>
              <Col lg={8}>
                <Form.Control
                  className={`${fieldClassName} text-muted`}
                  type="text"
                  value={device.node_id || ''}
                  disabled
                  readOnly
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="align-items-center g-2">
              <Form.Label column lg={4} className="mb-0 fw-semibold text-muted">
                System Type
              </Form.Label>
              <Col lg={8}>
                <Form.Control
                  className={`${fieldClassName} text-muted`}
                  type="text"
                  value={device.system_type || ''}
                  disabled
                  readOnly
                />
              </Col>
            </Form.Group>
          </Card.Body>
        </Card>

        <div className="d-flex justify-content-end align-items-center gap-3">
          <Button
            size="lg"
            onClick={handleSave}
            disabled={!hasChanges || saving}
            variant={hasChanges ? 'primary' : 'secondary'}
          >
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    </Container>
  );
}
